// extracted by css-extract-rspack-plugin
export default {"buttonsWrapper":"PlatformTour_buttonsWrapper__o7UK4","card":"PlatformTour_card__0zaE3","fadeInScale":"PlatformTour_fadeInScale__xrkI-"};